"use client";

import { PropsWithChildren } from "react";
import Close from "@/assets/close.svg";

const Modal = ({
  close,
  isOpen,
  children,
  className = "",
}: PropsWithChildren<{
  close: () => void;
  isOpen: boolean;
  className?: string;
}>) => {
  if (!isOpen) return null;
  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-black transition-opacity ${
          isOpen
            ? "opacity-80 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={close}
      />
      <div
        className={`z-50 fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#141416] px-8 py-9 border border-[#333] max-w-[90%] ${className}`}
      >
        <Close
          className="absolute top-4 right-4 w-8 h-8 text-white/60 cursor-pointer"
          onClick={close}
        />
        {children}
      </div>
    </>
  );
};

export default Modal;
